import { render, staticRenderFns } from "./DiscoverView.vue?vue&type=template&id=357ac7cc&scoped=true&"
import script from "./DiscoverView.vue?vue&type=script&lang=ts&"
export * from "./DiscoverView.vue?vue&type=script&lang=ts&"
import style0 from "./DiscoverView.vue?vue&type=style&index=0&id=357ac7cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357ac7cc",
  null
  
)

export default component.exports